var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('simc-picker',{attrs:{"model":_vm.schema,"field":_vm.simcField,"terc":_vm.schema.terc.$value}}),_c('ulic-picker',{attrs:{"disabled":_vm.disabled,"model":_vm.schema,"field":_vm.ulicField,"terc":_vm.schema.terc.$value,"simc":_vm.schema.simc.$value,"city":_vm.schema.city.$value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }